module.exports = __webpack_public_path__ + "img/webcalendar.png";